import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';

export const StyledStack = styled(Stack)({
  marginBottom: '12px'
});

export const Label = styled(Typography)(({ theme }) => ({
  display: 'block',
  fontWeight: '700',
  gridColumn: '2 / 3',
  marginBottom: '8px',
  marginLeft: '2px',
  fontSize: '14px',
  color: theme.palette.vpColors.black
}));

export const Required = styled(Typography)(({ theme }) => ({
  display: 'inline-block',
  marginLeft: '4px',
  color: theme.palette.vpColors.blueMain
}));

export const Error = styled(Typography)(({ theme }) => ({
  color: theme.palette.vpColors.redError,
  gridColumn: '2 / 3',
  marginLeft: '4px'
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/CampaignLandingElementWrapper/styles.js